export function isStaffEntryEditable(entry) {
    return (entry.msdyn_entryStatus === "Draft" || entry.msdyn_entryStatus === "Submitted" || entry.msdyn_entryStatus === "Returned")
        && !entry.crb7a_whmcsposted;
}
export function assertStaffResource(resources, resourceId) {
    const resource = resources.find((resource) => resource.bookableresourceid === resourceId);
    if (!resource) {
        throw new Error("This employee is not one of your direct reports. Refresh Staff Entries before trying again.");
    }
    return resource;
}
export function assertStaffEdit(resources, entry, patch) {
    const resource = assertStaffResource(resources, entry.bookableresource);
    if (!isStaffEntryEditable(entry)) {
        throw new Error("Only Draft, Submitted or Returned staff entries that have not been billed can be edited. Refresh Staff Entries.");
    }
    if (patch.bookableresource && patch.bookableresource !== entry.bookableresource) {
        throw new Error("An existing staff entry cannot be reassigned to another employee.");
    }
    return resource;
}
